export default {
    merge(target, source) {
    	if (typeof target !== 'object') {
			target = {}
		}
		if (Array.isArray(source)) {
			return source.slice()
		}
		for (const property in source) {
	    	if (source.hasOwnProperty(property)) {
	    		const sourceProperty = source[property]
		    	if (typeof sourceProperty === 'object') {
		    		target[property] = this.merge(target[property], sourceProperty)
		    		continue
		    	}
	    		target[property] = sourceProperty
	    	}
		}
		return target
    },
    deepClone(source){
		if (!source && typeof source !== 'object') {
			throw new Error('error arguments', 'shallowClone')
  		}
		const targetObj = source.constructor === Array ? [] : {}
		for (const keys in source) {
			if (source.hasOwnProperty(keys)) {
				if (source[keys] && typeof source[keys] === 'object') {
					targetObj[keys] = source[keys].constructor === Array ? [] : {}
					targetObj[keys] = this.deepClone(source[keys])
				} else {
					targetObj[keys] = source[keys]
				}
			}
		}
		return targetObj
    },
    isEmptyObject(obj){
		for (let key in obj){
			return false;
		}　　
		return true;
	},

	treeObjToArray(obj, children='children'){
		var resultArray = [];
		resultArray.push(obj)
		obj[children] && obj[children].map(item => {
			resultArray = resultArray.concat(this.treeObjToArray(item, children));
		})
		return resultArray;
	},

	//函数防抖
	debounce(func, wait, immediate) {
		let timeout, args, context, timestamp, result

		const later = function() {
			// 据上一次触发时间间隔
			const last = +new Date() - timestamp

			// 上次被包装函数被调用时间间隔last小于设定时间间隔wait
			if (last < wait && last > 0) {
				timeout = setTimeout(later, wait - last)
			} else {
				timeout = null
				// 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
				if (!immediate) {
					result = func.apply(context, args)
					if (!timeout) context = args = null
				}
			}
		}

		return function(...args) {
			context = this
			timestamp = +new Date()
			const callNow = immediate && !timeout
			// 如果延时不存在，重新设定延时
			if (!timeout) timeout = setTimeout(later, wait)
			if (callNow) {
				result = func.apply(context, args)
				context = args = null
			}
			return result
		}
	}
}


// WEBPACK FOOTER //
// ./src/js/object.js